module.exports = __webpack_public_path__ + "img/img13.7824bb58.png";